export const USER_AGENT: string = 'your-service/1.0.0';

export const VITE_AUTH0_DOMAIN: string = import.meta.env.VITE_AUTH0_DOMAIN;
export const VITE_AUTH0_AUDIENCE: string = import.meta.env.VITE_AUTH0_AUDIENCE;
export const VITE_AUTH0_CLIENT_ID: string = import.meta.env.VITE_AUTH0_CLIENT_ID;

export const VITE_URL_SERVICE: string = import.meta.env.VITE_URL_SERVICE || 'http://localhost:8080';
export const VITE_NAMESPACE: string = 'https://oauth.99minutos.com/';
